module.exports = __webpack_public_path__ + "img/table_1.a3df23a3.png";